/**
 * Shared Routing Aggregator
 *
 * Merges the shared base route tree with any template-specific extensions:
 *   - componentOverrides: replace the component for an existing base route key
 *   - additions:          add new routes not present in the base tree
 *   - exclusions:         remove specific route keys from the tree entirely
 *
 * This is the ONLY place where template variation is injected into routing.
 * Do not perform template branching in baseRoutes.js or AppShell.js.
 */

import baseRoutes from './baseRoutes';
import { resolveTemplate } from '../bootstrap/templateResolver';

/**
 * Build the final route array for the active template.
 * @returns {Array} Merged route definitions ready for react-router-dom
 */
export function buildRoutes() {
    const skin = process.env.SKIN || 'cpa';
    const templateConfig = resolveTemplate(skin);
    const extensions = templateConfig.routeExtensions || {};

    const { componentOverrides = {}, additions = [], exclusions = [] } = extensions;

    // Apply component overrides and exclusions to the base routes
    const mergedBase = baseRoutes
        .filter(route => !exclusions.includes(route.key))
        .map(route => {
            if (componentOverrides[route.key]) {
                return { ...route, component: componentOverrides[route.key] };
            }
            return route;
        });

    // Append template-specific additional routes
    return [...mergedBase, ...additions];
}
